import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { TimeConstants } from '../../../constants/time';
import { handleError } from '../../../utils/common';
import { useAlertModal } from '../../../utils/hook/hook';
import type { InfluencerCreatorRes } from '../dto/response/influencer-creator.res.dto';
import { RecipeApi } from '../recipe.api';

/**
 * 선정된 밥풀루언서 목록을 조회하는 React Query 훅
 */
export const useInfluencerCreatorsQuery = (
  options?: Omit<
    UseQueryOptions<InfluencerCreatorRes[]>,
    'queryKey' | 'queryFn' | 'meta'
  >,
) => {
  const { openAlertModal } = useAlertModal();

  const queryResult = useQuery({
    queryKey: RecipeApi.queryKeys.influencerCreators(),
    queryFn: () => RecipeApi.getInfluencerCreators(),
    staleTime: TimeConstants.FIVE_MINUTES,
    meta: {
      onError: (error: unknown) =>
        handleError(openAlertModal, error, '밥풀루언서 목록 조회'),
    },
    ...options,
  });

  return {
    influencerCreators: queryResult.data ?? [],
    ...queryResult,
  };
};
